### 1. Uruchamiamy program MS Access.
### 2. Na stronie głównej wybieramy opcję "Pusta baza danych".
![](https://i.imgur.com/8jJ18km.png)
### 3. Oto widok, jaki powinniśmy zobaczyć.
![](https://i.imgur.com/JYzhPny.png)
